import * as types from './reportActionType';

export const fetchPowerBIReportRequest = (data) => ({
    type: types.FETCH_POWER_BI_REPORT_REQUEST,
    payload: data
});
export const fetchPowerBIReportSuccess = (data) => ({
    type: types.FETCH_POWER_BI_REPORT_SUCCESS,
    payload: data
});
export const fetchPowerBIReportFailure = (error) => ({
    type: types.FETCH_POWER_BI_REPORT_FAILURE,
    payload: error
});